import { FormControlLabel, Switch } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useFormContext } from 'react-hook-form';
import { presentationSlotTypes } from '../../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../../reduxToolkit/typedRedux';
import VyTextField from '../../../../../../../common/VyTextField';

export const SeatSelect = ({ presentationSlotType }: { presentationSlotType: presentationSlotTypes }) => {
  const { register } = useFormContext();
  const { t } = useTranslation();
  const event = useSelector((state) => state.common.event);

  return (
    <>
      {(presentationSlotType === 'on-site' ||
        presentationSlotType === 'hybrid' ||
        (presentationSlotType === 'online' && event?.settings?.enableOnlinePresentationBooking)) && (
        <>
          <VyTextField register={register('presentationMaxSeats', { required: true })} label={t('account:presentation.seats-number')} fullWidth type="number" />
          <div className="w-full">
            <FormControlLabel label={t('account:presentation.require-signup')} control={<Switch {...register('presentationRequireSignup')} defaultChecked />} />
          </div>
        </>
      )}
    </>
  );
};
